









































import 'vue-awesome/icons/chevron-right'
import 'vue-awesome/icons/chevron-down'
import 'vue-awesome/icons/list'
import 'vue-awesome/icons/exclamation-triangle'
import 'vue-awesome/icons/pencil-alt'

export default
  name: 'account_category'
  props: ['category']
  components:
    balance: require('components/inside/elements/balance.vue').default
    editable_balance: require('./editable_balance.vue').default
    account_forecast: require('./account_forecast.vue').default
  computed:
    children: -> @category.children()
    in_budget_sum: ->
      accs = @children.filter (acc) -> acc.isInBudget()
      _.sumBy accs, (acc) => acc.universalBalance(@$store.getters.default_currency)
    out_of_budget_sum: ->
      accs = @children.filter (acc) -> !acc.isInBudget()
      _.sumBy accs, (acc) => acc.universalBalance(@$store.getters.default_currency)
  beforeDestroy: ->
    requestIdleCallback =>
      @sortable.destroy()
      @sortable = null
  mounted: ->
    component = @
    requestIdleCallback =>
      @sortable = new Sortable $(@$el).find('tbody')[0],
        group: 'accounts'
        sort: true
        delay: (if @HM.is_touch then 100 else 0)
        draggable: '.account-row'
        handle: '.account-name'
        onSort: (evt) ->
          component.sortAccounts(@el.dataset.id, @toArray())
          component.$forceUpdate()
  methods:
    history: (account) ->
      @$store.dispatch 'showTransactionsHistory',
        mode: 'account'
        filter: { account_id: account.id }
    edit: (account)   -> @$store.commit 'ACCOUNTS/EDIT', account
    editCategory: (category) -> @$store.commit 'ACCOUNT_CATEGORIES/EDIT', category
    editMobile: (account) ->
      return if !HM.is_mobile
      @edit(account)
    sortAccounts: (category_id, account_ids) ->
      payload =
        category_id: category_id
        account_ids: account_ids
      @$store.dispatch('sortAccounts', payload).then (res) =>
        HM.track "account-sort"
        @$message
          message: @$t('Done')
          type: 'success'

